package model

import kotlinx.serialization.Serializable

@Serializable
data class TokenAuthenticationBody(
    val guid: String
)